import { defineMessages } from 'react-intl';

export default defineMessages({
  labelPurchased: {
    description: 'shipment-status.labelPurchased',
    defaultMessage: 'Label Purchased',
    id: 'o/lA4/',
  },
  labelPrinted: {
    description: 'shipment-status.labelPrinted',
    defaultMessage: 'Label Printed',
    id: 'boAa3R',
  },
  printed: {
    description: 'shipment-status.printed',
    defaultMessage: 'Printed',
    id: 'xTaoOv',
  },
  purchased: {
    description: 'shipment-status.purchased',
    defaultMessage: 'Purchased',
    id: 'LFozhD',
  },
  label: {
    description: 'shipment-status.label',
    defaultMessage: 'Label',
    id: 'aMh9oK',
  },
});
